import axios from "axios";

const API = process.env.REACT_APP_JOB_BOARD_API_URL;

export const getAdminJobs = async (params, token) => {
  const res = await axios.get(`${API}/admin/jobs`, {
    params,
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};

export const updateJobStatus = async (jobId, status, token) => {
  await axios.patch(
    `${API}/admin/jobs/${jobId}/status`,
    { status },
    { headers: { Authorization: `Bearer ${token}` } }
  );
};

export const bulkJobAction = async (action, jobIds, token) => {
  await axios.patch(
    `${API}/admin/jobs/bulk`,
    { action, jobIds },
    { headers: { Authorization: `Bearer ${token}` } }
  );
};